import {
  useEffect,
} from 'react';
import type {
  PropsWithChildren,
  ReactElement,
} from 'react';

import {
  ThemeProvider,
} from 'styled-components';

import {
  setTheme,
} from '@n3/css-base';
import type {
  ThemeType,
} from '@n3/css-base';

export type ProviderProps = PropsWithChildren<{
  /**
   * Тема в формате @n3/css-base
   */
  theme: ThemeType;
}>;

export function Provider({
  children = undefined,
  theme,
}: ProviderProps): ReactElement {
  useEffect(() => {
    setTheme(theme);
  }, [theme]);

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
}
